import CalendarService from '../lib/services/CalendarService';
import { injectLogos } from '../lib/utils';

const fetchGuidance = (params = {}, injectTickersLogos = true, pageSize = 1000): Promise<any> => {
  const query = {
    ...params,
    pagesize: pageSize,
  };

  const Calendar = new CalendarService();

  return Calendar.getGuidance(query).then(({ data }: any) => {
    const items: any = [];
    if (Array.isArray(data.guidance) && data.guidance.length) {
      return injectTickersLogos ? injectLogos(data.guidance) : data.guidance;
    }
    return items;
  });
};

export { fetchGuidance };
